export class Projectcomment {
    commentId:string;
    projectId:string;
    projectcomment:string;
    comment_type:string;
    related_task:string;
    parent_comment:string;
    creator:string;
    created:Date;
    commentvisibility:string;
    projectname:string;
    projectdescription:string;
    organizationId:string;
    organizationname:string;
    orgdesc:string;
    orgemail:string;
    orgwww:string;
    orglogourl:string;
    customer:string;
    customername:string;
}